import { LoadMoreFn } from "react-relay";
import { OperationType } from "relay-runtime";
import LoadMore from "@/components/LoadMore";
import { WorkspaceCard, WorkspaceCardProps } from "@/components/WorkspaceCard";

interface WorkspaceCardGridProps<T extends OperationType> {
  edges: ReadonlyArray<{
    readonly node: { readonly id: string } & WorkspaceCardProps["workspace"];
  }>;
  loadMore: LoadMoreFn<T>;
  hasMore: boolean;
  isLoading: boolean;
}

export default function WorkspaceCardGrid<T extends OperationType>({
  edges,
  loadMore,
  hasMore,
  isLoading,
}: WorkspaceCardGridProps<T>) {
  return (
    <>
      <ul className="grid xl:grid-cols-2 grid-cols-1 gap-6">
        {edges.map(({ node }) => (
          <WorkspaceCard workspace={node} asElement="li" key={node.id} />
        ))}
      </ul>

      <div className="inline-flex justify-center items-center">
        <LoadMore
          loadMore={loadMore}
          hasMore={hasMore}
          isLoading={isLoading}
          className="w-full md:w-auto"
        />
      </div>
    </>
  );
}
